import { useField } from 'formik';
import { FC, useCallback, useContext } from 'react';

import { Dropdown, DropdownProps } from '../Dropdown';
import { IsRequiredFieldContext } from './Form';

export type FormDropdownProps = Omit<
  DropdownProps,
  'value' | 'required' | 'ref' | 'helperText'
> & {
  name: string;
  excludeTranslation?: boolean;
};

export const FormDropdown: FC<FormDropdownProps> = props => {
  const isRequired = useContext(IsRequiredFieldContext)[props.name] ?? false;

  const [field, meta, helpers] = useField(props.name);

  const onChange = useCallback(
    value => {
      helpers.setValue(value);

      if (props.onChange) {
        props.onChange(value);
      }
    },
    [helpers.setValue, props.onChange]
  );

  const onBlur = useCallback(
    e => {
      helpers.setTouched(true);

      if (props.onBlur) {
        props.onBlur(e);
      }
    },
    [helpers.setTouched, props.onBlur]
  );

  return (
    <Dropdown
      {...props}
      error={!!meta.error && !!meta.touched}
      errorMessage={meta.touched ? meta.error : undefined}
      formField
      id={props.id || props.name}
      onBlur={onBlur}
      onChange={onChange}
      required={isRequired}
      value={field.value ?? ''}
    />
  );
};

FormDropdown.displayName = 'FormDropdown';
